import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useTranslate } from 'sbx-crm-menu-ui';
import botIcon from '../../../../assets/images/SBX360Bot.png';
import { AppAgentContext } from '../../../../context/ContextProvider';
import { State } from '../../../../types/State';
import ChatBotMessageComponent from './ChatBotMessageComponent';
import { askToBotService } from '../../../../services/ChatService';
import ChatContainerMessage from './ChatContainerMessage';
import ChatInputComponent from './ChatInputComponent';

// const baseOptionsToBot: AIInstruction[] = [
//     {label: "Usar este mensaje para res", instruction: "En una conversación con el cliente debemos responder a la siguiente pregunta:"}
// ]


const messagesToBot: any = [];
export interface ChatRefComponent {
    sendMessage: (message: string) => void;
}

function replaceTranscriptionContent(input: string): string {
    // Expresión regular para encontrar el contenido entre {transcription} y {/transcription}
    const regex = /{transcription}.*?{\/transcription}/gs;
    // Reemplaza el contenido encontrado por una cadena vacía
    return input.replace(regex, '');
}

type Props = {
    transcription: string;
    sessionId: string
};


const ChatBotComponent = forwardRef<ChatRefComponent, Props>(({transcription, sessionId}, ref) => {


    const { state: { session } } = React.useContext(AppAgentContext);
    const { t } = useTranslate('common');
    const { t: omnichannel } = useTranslate('omnichannel');
    const refContent = useRef<HTMLDivElement>(null);
    const [messages, setMessages] = useState<{
        message: string,
        author: string
    }[]>([
        {
            message: omnichannel('support_chat_bot_initial_message') ?? 'Estoy listo para resolver todas tus inquietudes',
            author: 'bot',
        },
    ]);

    const [loading, setLoading] = useState(State.IDLE);

    useImperativeHandle(ref, () => ({
        sendMessage: (text) => {
            sendMessage(text);
        }
    }), []);

    const sendMessage = useCallback(async (text: string) => {
        setLoading(State.PENDING);
        setMessages(prevState => (
            [...prevState, { message: replaceTranscriptionContent(text), author: 'host' }]
        ));

        const response = await askToBotService({session_id: sessionId,  question: `\\n\\n {transcription} ${transcription} {/transcription} \\n\\n ${text}`, agent_id: session.ai_agent_config?.agent_id });
        if (response?.success) {
            setMessages(prevState => ([...prevState, {
                message: response.result, author: 'bot',
            }]));
            setLoading(State.RESOLVED);
        } else {
            setMessages(prevState => ([...prevState, {
                message: omnichannel('support_chat_bot_no_respond') ?? 'No se pudo obtener respuesta, por favor intenta de nuevo',
                author: 'bot',
            }]));
            setLoading(State.REJECTED);
        }
    }, [session.ai_agent_config, transcription]);

    useEffect(() => {

        if (messagesToBot.length > 0) {
            sendMessage(messagesToBot[messagesToBot.length - 1]);
        }

    }, [messagesToBot, sendMessage]);

    useEffect(() => {

        if (messages.length > 0 && refContent.current) {
            refContent.current.scrollTop = refContent.current.scrollHeight;
        }

    }, [messages]);


    return (
        <div className="flex flex-col">
            <div
                className="overflow-y-auto h-[56.6vh] lg:h-[61vh] 2xl:h-[76.5vh] bg-[#F2EFFE]  px-4  py-2 flex flex-col gap-2"
                ref={refContent}>
                {/*<ChatBodyMessagesComponent/>*/}
                {
                    messages.map((message, index) => {
                        return <ChatBotMessageComponent key={index} message={message} />;

                    })
                }
                {
                    loading === State.PENDING && <div className="flex flex-col">
                        <div className="flex items-center gap-1">
                            <div>
                                <img src={botIcon} alt={'SBX360 bot icon'} className="w-[32px] h-[32px]" />
                            </div>
                            <ChatContainerMessage host={false}
                                                  messageBody={<div
                                                      className={`bg-[#8D35D8]  text-white rounded-2xl shadow p-3 text-sm`}>
                                                      {t('typing')}...
                                                  </div>}
                                                  author={''} />
                        </div>
                    </div>
                }
            </div>


            <ChatInputComponent key={'chat_bot_input'} sendMessage={sendMessage} />
        </div>
    );
});

export default ChatBotComponent;